import script from "./JobFormModal.vue?vue&type=script&setup=true&lang=js"
export * from "./JobFormModal.vue?vue&type=script&setup=true&lang=js"

import "./JobFormModal.vue?vue&type=style&index=0&id=2e806857&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e806857"]])

export default __exports__